<template>
    <div
        class="service-frequency__container"
        :class="{ 'most-popular': mostPopular }"
        @click="selectPriceOption()"
    >
        <div
            class="ls-button ls-button--block ls-button--radio"
            :class="{
                'ls-button--green ls-button--faded': optionSelected,
            }"
        >
            <span class="service-frequency__text-title" data-font-size="-1">
                {{ priceOption.price.cycle | lsCycle }}
                <br v-if="!screenSize.xs" />
                {{ priceOption.service.name | lsServiceName }}
            </span>
            <br />
            <span
                v-if="priceOption.price.price"
                class="service-frequency__text-price"
                data-font-size="-3"
                >${{ priceOption.price.price }} / service</span
            >
            <span v-else class="service-frequency__text-quote" data-font-size="-3"
                >Custom quote</span
            >

            <span v-if="!renderAsButton" class="ls-button-toggle-icon ls-color--gray--light">
                <i
                    class="fa"
                    :class="{
                        'fa-circle-thin': !optionSelected,
                        'fa-check-circle ls-color--green--color-dodge': optionSelected,
                    }"
                ></i>
            </span>
        </div>
        <p v-if="mostPopular" class="most-popular__text" data-font-size="-2">Most Popular</p>
    </div>

    <!-- Structure to get radio select appearance -->
    <!--<label class="ls-button ls-button&#45;&#45;block ls-button&#45;&#45;radio">-->
    <!--<span class="ls-button-toggle-icon ls-color-gray&#45;&#45;light">-->
    <!--<i class="fa fa-circle-thin"></i>-->
    <!--</span>-->
    <!--</label>-->
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
    props: {
        priceOption: {
            type: Object,
            required: true,
        },
        selectedPriceOption: {
            type: Object,
        },
        renderAsButton: {
            type: Boolean,
        },
        mostPopular: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState(['screenSize']),
        optionSelected() {
            return (
                _.get(this.selectedPriceOption, 'price.price_id') ===
                _.get(this.priceOption, 'price.price_id')
            );
        },
    },
    methods: {
        selectPriceOption() {
            this.$emit('priceOptionSelected', this.priceOption);
        },
    },
};
</script>

<style lang="scss">
.service-frequency__container {
    position: relative;
    padding: 12px;
    border-radius: 3px;

    &.most-popular {
        background: palette(green, xx-light);
        padding-bottom: 20px;

        .ls-button-toggle-icon {
            background: palette(green, xx-light);
        }
    }
    .most-popular__text {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 3px;
        padding: 0 12px;

        color: palette(green);
        font-weight: 800;
        text-align: center;
    }
}
</style>
